<template>
  <div style="padding: 20px 0px 0px 20px;">

     <div v-if="isLayer === 1">
        <el-form style="display: flex;flex-wrap: wrap;">

          <el-form-item label="订单号:" style="display: flex;width: 33%;">
            <el-input v-model="input333" placeholder="请输入订单号"></el-input>
          </el-form-item>


          <el-form-item label="城市:" style="display: flex;width: 33%;">
          <el-select placeholder="请选择城市" v-model="input1" style="width: 100%" clearable filterable>
            <el-option v-for="item in optionList1" :key="item.id" :value="item.id" :label="item.realname"></el-option>
          </el-select>
          </el-form-item>


          <el-form-item label="学生:" style="display: flex;width: 33%;">
          <el-select placeholder="请选择学生" v-model="input1" style="width: 100%" clearable filterable>
            <el-option v-for="item in optionList1" :key="item.id" :value="item.id" :label="item.realname"></el-option>
          </el-select>
          </el-form-item>

          <el-form-item label="学生类型:" style="display: flex;width: 33%;">
          <el-select placeholder="请选择学生类型" v-model="input1" style="width: 100%" clearable filterable>
            <el-option v-for="item in optionList1" :key="item.id" :value="item.id" :label="item.realname"></el-option>
          </el-select>
          </el-form-item>


          <el-form-item label="销售:" style="display: flex;width: 33%;">
          <el-select placeholder="请选择销售" v-model="input1" style="width: 100%" clearable filterable>
            <el-option v-for="item in optionList1" :key="item.id" :value="item.id" :label="item.realname"></el-option>
          </el-select>
          </el-form-item>


          <el-form-item label="发票抬头:" style="display: flex;width: 33%;">
            <el-input v-model="input333" placeholder="请输入发票抬头"></el-input>
          </el-form-item>


          <el-form-item label="发票开具方:" style="display: flex;width: 33%;">
          <el-select placeholder="请选择发票开具方" v-model="input1" style="width: 100%" clearable filterable>
            <el-option v-for="item in optionList11" :key="item.id" :value="item.id" :label="item.realname"></el-option>
          </el-select>
          </el-form-item>


          <el-form-item label="开票状态:" style="display: flex;width: 33%;">
          <el-select placeholder="请选择开票状态" v-model="input1" style="width: 100%" clearable filterable>
            <el-option v-for="item in optionList111" :key="item.id" :value="item.id" :label="item.realname"></el-option>
          </el-select>
          </el-form-item>


              
          <el-form-item label="申请日期:" style="display: flex;width: 60%;">
          <el-date-picker v-model="input2" type="daterange"   range-separator="至" value-format="yyyy-MM-dd"  start-placeholder="开始日期"   end-placeholder="结束日期"></el-date-picker>
          </el-form-item>


          <div style="display: flex;justify-content: end;width: 100%;margin-top: 10px;margin-bottom: 30px;">
          <!-- <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-plus"  @click="searchAddBtns">新增发票申请</el-button> -->
          <!-- <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-download" @click="exportBtns">导出</el-button> -->
          <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search"   @click="searchBtns">搜索</el-button>
          <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close"   @click="clearBtns">清空</el-button>
          </div>

        </el-form>


          <el-table :header-cell-style="{ background: '#fafafa', 'text-align': 'center' }" :cell-style="{ 'text-align': 'center' }" :data="dataList" border height="700" >
            <el-table-column width="150" prop="teacherName" label="订单号" show-overflow-tooltip></el-table-column>
            <el-table-column width="150" prop="integralSum" label="城市" show-overflow-tooltip></el-table-column>
            <el-table-column width="150" prop="integralSum" label="学生" show-overflow-tooltip></el-table-column>
            <el-table-column width="150" prop="integralSum" label="学生类型" show-overflow-tooltip></el-table-column>
            <el-table-column width="150" prop="integralSum" label="销售" show-overflow-tooltip></el-table-column>
            <el-table-column width="150" prop="integralSum" label="发票抬头" show-overflow-tooltip></el-table-column>
            <el-table-column width="200" prop="integralSum" label="发票开具方"   show-overflow-tooltip></el-table-column>
            <el-table-column width="150" prop="teacherId"   label="发票类型" show-overflow-tooltip></el-table-column>
            <el-table-column width="150" prop="integralSum" label="开票金额" show-overflow-tooltip></el-table-column>
            <el-table-column width="150" prop="integralSum" label="申请日期" show-overflow-tooltip></el-table-column>
            <el-table-column width="150" prop="integralSum" label="开票状态" show-overflow-tooltip>
            <template v-slot="scope">
              <span v-if="scope.row.auditStatus === 1">开票中</span>
              <span v-if="scope.row.auditStatus === 2">开票完成</span>
              <span v-if="scope.row.auditStatus === 3">已冲销/</span>
              <span v-if="scope.row.auditStatus === 4">冲销中</span>
              <span v-if="scope.row.auditStatus === 5">驳回</span>
            </template>
            </el-table-column>


            <!-- <el-table-column prop="classFee" label="添加时间" show-overflow-tooltip></el-table-column> -->
            <!-- <el-table-column prop="auditStatus" label="项目状态" show-overflow-tooltip>
            <template v-slot="scope">
              <div style="display: flex;justify-content: space-around;color:rgb(255 54 0);"
                v-if="scope.row.auditStatus === 0">无效</div>
              <div style="display: flex;justify-content: space-around;color:rgb(23 226 31);"
                v-if="scope.row.auditStatus === 1">有效</div>
            </template>
            </el-table-column> -->
            <el-table-column label="操作"  width="200">
            <template v-slot="scope">
              <div style="display: flex;justify-content: space-around;">
                <el-button type="text" style="color:#00aaff;" @click="handleClickView('详情', scope.row)">发票详情</el-button>
                <el-button type="text" style="color:#ed142a;" @click="handleClickViewTo('冲销', scope.row)">冲销</el-button>
                <!--  <el-button type="text" style="color:#00aaff;" @click="handleClickView('删除', scope.row)">删除</el-button> -->
              </div>
            </template>
            </el-table-column>
          </el-table>

          <el-pagination  @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"  :page-size="pageSize" layout="prev, pager, next,sizes, jumper" :total="total">
          </el-pagination>
     </div>
    



     <div v-if="isLayer === 2">

      <el-form style="display: flex;flex-wrap: wrap;">

        <el-form-item label="订单号:" style="display: flex;width: 33%;">
          <el-input v-model="input333" placeholder="请输入订单号"></el-input>
        </el-form-item>


        <el-form-item label="城市:" style="display: flex;width: 33%;">
        <el-select placeholder="请选择城市" v-model="input1" style="width: 100%" clearable filterable>
          <el-option v-for="item in optionList1" :key="item.id" :value="item.id" :label="item.realname"></el-option>
        </el-select>
        </el-form-item>


        <el-form-item label="学生:" style="display: flex;width: 33%;">
        <el-select placeholder="请选择学生" v-model="input1" style="width: 100%" clearable filterable>
          <el-option v-for="item in optionList1" :key="item.id" :value="item.id" :label="item.realname"></el-option>
        </el-select>
        </el-form-item>

        <el-form-item label="学生类型:" style="display: flex;width: 33%;">
        <el-select placeholder="请选择学生类型" v-model="input1" style="width: 100%" clearable filterable>
          <el-option v-for="item in optionList1" :key="item.id" :value="item.id" :label="item.realname"></el-option>
        </el-select>
        </el-form-item>

            
        <el-form-item label="收款日期:" style="display: flex;width: 60%;">
          <el-date-picker v-model="input2" type="daterange"   range-separator="至" value-format="yyyy-MM-dd"  start-placeholder="开始日期"   end-placeholder="结束日期"></el-date-picker>
        </el-form-item>


        <div style="display: flex;justify-content: end;width: 100%;margin-top: 10px;margin-bottom: 30px;">
          <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search"   @click="searchBtns">搜索</el-button>
          <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close"   @click="clearBtns">清空</el-button>
        </div>

        </el-form>


        <div style="text-align: end; padding: 27px;">
           <span>本次申请</span> <span style="color: red;">{{ dataList.length + 1 }}</span> <span> 个账单</span> <span>总计开票金额</span><span>1000</span><span>元</span><span style="margin-left: 20px;color: #00aaff;" @click="handleClickViewsTo">去申请</span>
        </div>

        <el-table :header-cell-style="{ background: '#fafafa', 'text-align': 'center' }" :cell-style="{ 'text-align': 'center' }" :data="dataList" border height="700" >
          <el-table-column width="150" prop="teacherName" label="订单号" show-overflow-tooltip></el-table-column>
          <el-table-column width="150" prop="integralSum" label="城市" show-overflow-tooltip></el-table-column>
          <el-table-column width="150" prop="integralSum" label="学生" show-overflow-tooltip></el-table-column>
          <el-table-column width="150" prop="integralSum" label="学生类型" show-overflow-tooltip></el-table-column>
          <el-table-column width="150" prop="integralSum" label="销售" show-overflow-tooltip></el-table-column>
          <el-table-column width="150" prop="integralSum" label="客资类型" show-overflow-tooltip></el-table-column>
          <el-table-column width="150" prop="integralSum" label="应开发票金额"   show-overflow-tooltip></el-table-column>
          <el-table-column width="150" prop="integralSum" label="开票状态" show-overflow-tooltip>
          <template v-slot="scope">
            <span v-if="scope.row.auditStatus === 1">开票中</span>
            <span v-if="scope.row.auditStatus === 2">开票完成</span>
            <span v-if="scope.row.auditStatus === 3">已冲销/</span>
            <span v-if="scope.row.auditStatus === 4">冲销中</span>
            <span v-if="scope.row.auditStatus === 5">驳回</span>
          </template>
          </el-table-column>
        </el-table>

        <el-pagination  @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"  :page-size="pageSize" layout="prev, pager, next,sizes, jumper" :total="total">
        </el-pagination>
    
     </div>



     <div v-if="isLayer === 3">

        <div style="text-align: start;">
          <span style="font-weight: 900; font-size: 15px;margin-right: 6px;">发票开具方：</span><span>北京博川立信信息咨询有限公司/北京桑穆规划咨询中心（个体工商户）</span>
        </div>
        <div style="text-align: start;margin: 15px 0px;">
          <span style="font-weight: 900; font-size: 15px;">发票基础信息</span>
        </div>

        <div style="width: 100%;height: 1px;background-color: black;"></div>

        <div>

          <div style="display: flex;margin: 25px 0px; padding-left: 100px;">
            <span style="margin-top: 10px; color: red;">*</span>
            <span style="margin-top: 10px;">发票类型：</span>
            <span>
              <el-select placeholder="请选择学生类型" s v-model="input1" style="width: 100%" clearable filterable>
                <el-option v-for="item in optionList1" :key="item.id" :value="item.id" :label="item.realname"></el-option>
              </el-select>
            </span>
          </div>

          <div style="display: flex;margin: 25px 0px; padding-left: 100px;">
            <span style="margin-top: 10px; color: red;">*</span>
            <span style="margin-top: 10px;">发票抬头：</span>
            <span>
              <el-input v-model="input333" placeholder="请输入发票抬头" style="width: 107%" ></el-input>
            </span>
          </div>


         <div style="display: flex;">
            <div style="display: flex;margin: 25px 0px; padding-left: 100px;">
              <span style="margin-top: 10px; color: red;">*</span>
              <span style="margin-top: 10px;">抬头类型：</span>
              <span style="padding-top: 14px;">
                <el-radio v-model="radio1" label="1">个人</el-radio>
                <el-radio v-model="radio1" label="2">企业</el-radio>
              </span>
            </div>
            <div style="display: flex;margin: 25px 0px; padding-left: 228px;">
              <span v-if="radio1 === '2'" style="margin-top: 10px; color: red;">*</span>
              <span style="margin-top: 10px;">纳税人识别号：</span>
              <span>
                <el-input v-model="input333" placeholder="请输入纳税人识别号" style="width: 107%" ></el-input>
              </span>
            </div>
         </div>

         <div style="display: flex;">
            <div style="display: flex;margin: 15px 0px; padding-left: 100px;">
              <span style="margin-top: 10px;"></span>
              <span style="margin-top: 10px;width: 120px;">地址：</span>
              <span style="">
                <el-input v-model="input333" placeholder="请输入地址" style="width: 107%" ></el-input>
              </span>
            </div>
            <div style="display: flex;margin: 15px 0px; padding-left: 100px;">
              <span style="margin-top: 10px;"></span>
              <span style="margin-top: 10px;width: 120px;">手机号：</span>
              <span>
                <el-input v-model="input333" :maxlength="11"  :minlength="11" placeholder="请输入手机号" style="width: 107%" ></el-input>
              </span>
            </div>
         </div>


         <div style="display: flex;">
            <div style="display: flex;margin: 15px 0px; padding-left: 100px;">
              <span style="margin-top: 10px;"></span>
              <span style="margin-top: 10px;width: 120px;margin-left: 1px;">开户行名称：</span>
              <span style="">
                <el-input v-model="input333" placeholder="请输入开户行名称" style="width: 107%" ></el-input>
              </span>
            </div>
            <div style="display: flex;margin: 15px 0px; padding-left: 100px;">
              <span style="margin-top: 10px;"></span>
              <span style="margin-top: 10px;width: 120px;">开户行账号：</span>
              <span>
                <el-input v-model="input333" placeholder="请输入开户行账号" style="width: 107%" ></el-input>
              </span>
            </div>
         </div>

        </div>


        <div style="text-align: start;margin: 15px 0px;">
          <span style="font-weight: 900; font-size: 15px;">收票人信息</span>
        </div>

        <div style="width: 100%;height: 1px;background-color: black;"></div>

        <div style="display: flex;">
            <div style="display: flex;margin: 15px 0px; padding-left: 100px;">
              <span style="margin-top: 10px;color: red;">*</span>
              <span style="margin-top: 10px;width: 120px;">收票人邮箱：</span>
              <span style="">
                <el-input v-model="input333" placeholder="请输入邮箱" style="width: 107%" ></el-input>
              </span>
            </div>
            <div style="display: flex;margin: 15px 0px; padding-left: 100px;">
              <span style="margin-top: 10px;"></span>
              <span style="margin-top: 10px;width: 120px;">收票人手机号：</span>
              <span>
                <el-input v-model="input333" :maxlength="11"  :minlength="11" placeholder="请输入手机号" style="width: 107%" ></el-input>
              </span>
            </div>
         </div>


         <div style="margin: 15px 0px; text-align: end;">
          <el-button  size="small" type="danger" @click="handleSubt">完成开票</el-button>
          <el-button size="small" @click="handleCler">取消开票</el-button>
          <el-button  size="small" type="warning" @click="handleSubtTo">驳回开票</el-button>
         </div>



        <div style="width: 100%;height: 1px;background-color: black;"></div>
        <div style="text-align: start;margin: 15px 0px;">
          <span style="font-weight: 900; font-size: 15px;">本次申请账单列表</span>
        </div>

        <div style="text-align: start;padding: 15px 5px; border: 1px solid #d9d9d9;background: #dddddd;">
          <span>发票开具方:</span><span style="font-weight: 900;">北京博川立信信息咨询有限公司</span>
          <span>申请开票总金额:</span><span style="font-weight: 900;">1000元</span>
        </div>
        <el-table :header-cell-style="{ background: '#fafafa', 'text-align': 'center' }" :cell-style="{ 'text-align': 'center' }" :data="dataList" border height="700" >
          <el-table-column width="150" prop="integralSum" label="收款日期" show-overflow-tooltip></el-table-column>
          <el-table-column width="150" prop="teacherName" label="订单号" show-overflow-tooltip></el-table-column>
          <el-table-column width="150" prop="integralSum" label="城市" show-overflow-tooltip></el-table-column>
          <el-table-column width="150" prop="integralSum" label="学生" show-overflow-tooltip></el-table-column>
          <el-table-column width="150" prop="integralSum" label="学生类型" show-overflow-tooltip></el-table-column>
          <el-table-column width="150" prop="integralSum" label="销售" show-overflow-tooltip></el-table-column>
          <el-table-column width="150" prop="integralSum" label="客资类型" show-overflow-tooltip></el-table-column>
          <el-table-column width="150" prop="integralSum" label="应开发票金额"   show-overflow-tooltip></el-table-column>
        </el-table>
         
     </div>





  </div>
</template>


<script>
import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
import axios from "axios";
import apiBaseUrl from "../../config/api";
import { getTeachers } from "@/api/fiveClassApi"


export default {
  components: {

  },
  data() {
    return {
      isTooffset:false,
      radio1:'',

      isLayer:1,

      ishowoTypeDisabled: false,

      value1: '',
      value2: [],
      value3: [],

      integralCount: 0,


      input33:'',
      input333:'',



      inputValue1: '',
      inputValue2: 0 ,
      inputValue3: '',

      Titlecenter: '添加积分项目',
      optionList4: [{ id: 0, name: '无效' }, { id: 1, name: '有效' }],

      optionList1: [],
      optionList11: [
        { realname:'北京博川立信信息咨询有限公司/北京桑穆规划咨询中心（个体工商户）' , id: 1}
      ],

      optionList111: [
        { realname:'开票中' , id: 1},
        { realname:'开票完成' , id: 2},
        { realname:'已冲销' , id: 3},
        { realname:'冲销中' , id: 4},
        { realname:'驳回' , id: 5},
      ],

      optionList2: [],
      optionList3: [{ id: 0, name: '待审批' }, { id: 1, name: '驳回' }, { id: 2, name: '已完成' }],

      input1: '',
      input2: [],
      input3: '',

      dataList: [],

      pageNum: 1,
      pageSize: 10,
      total: 0,


      pageNum1: 1,
      pageSize1: 10,
      total1: 0,

      CourseCancellationComponentsType: '',
      CourseCancellationComponentsID: '',
      CourseCancellationComponentsShow: false,

      CourseCancellationomponentsTypeDistinguish: '课消审批',

      dataList1:[],


      addShow: false,

      inputID:'',

      optionList5:[],
      teacherIditme:null,


      resumeNumber3Id:'',
      resumeNumber3:'',

      dataTrees:[],
      defaultPropss:{ children: 'children', label: 'deptName' }, 


      input11:'',
      resumeNumber33:'',
      resumeNumber33Id:'',
      input3333:'',
      input333333:'',
      input2222:'',

      summaryData: {
        teacherId: 0, // 金额
      },

    }
  },

  created(){
    this.getApiList()
  },

  mounted() {
    getTeachers().then(res => { this.optionList1 = res.data })
    axios.get(`${apiBaseUrl}/questionnaire/queryCreator`, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => { this.optionList2 = res.data.data })
    axios.get(`${apiBaseUrl}/organizational/getOrgTree`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{ this.dataTrees = res.data.data})

    this.handleintegralProject()

    setTimeout(() => {
      this.$nextTick(() => {
         this.getApiList();
      });
    }, 0);

  },


  methods: {

    handleTreeCheck(e){
      this.resumeNumber3 = e.deptName
      this.resumeNumber3Id = e.deptId
      this.$refs.treeSelect1.visible = false
    },


    handleTreeChecks(e){
      this.resumeNumber33 = e.deptName
      this.resumeNumber33Id = e.deptId
      this.$refs.treeSelect2.visible = false
    },

    handleintegralProject(){
      axios.post(`${apiBaseUrl}/integralProject/findList`, { integralName:'' }, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
        if (res.data.code === 200) {
          let data = res.data.data
          this.optionList5 = data
        } else {
          this.optionList5 = []
          this.$message.error(res.data.message)
        }
      }).catch((err) => {
        this.$message.error(err)
      })
    },


    handleCler(){
      this.isLayer = 1
    },

    handleSubt(){
      this.$message.success('保存成功')
      this.isLayer = 1
    },

    handleSubtTo(){
      this.isLayer = 1
    },

    handleClickViewBtn(type){


      if(type === '保存'){
        this.$message.success('保存成功')
        this.addShow = false
        this.input11 = ''
        this.resumeNumber33 = ''
        this.input3333 = ''
        this.input333333 = ''
        this.input2222 = ''
      }

      if(type === '取消'){
          this.inputValue1 = ''
          this.inputValue2 = 0
          this.inputValue3 = ''
          this.Titlecenter = ''
          this.inputID = ''
          this.addShow = false

          this.input11 = ''
          this.resumeNumber33 = ''
          this.input3333 = ''
          this.input333333 = ''
          this.input2222 = ''

      }

      if(type === '确定'){

        if(this.inputValue1 === ''){
          this.$message.warning('请输入项目名称')
          return
        }

        if(this.inputValue3 === ''){
          this.$message.warning('请选择项目状态')
          return
        }

        let data = {
          name: this.inputValue1,
          score: this.inputValue2,
          status: this.inputValue3,
          id: this.inputID,
        }

      }

    },

    searchAddBtns() {
      this.isLayer = 2
      this.Titlecenter = '新增发票申请'
      this.addShow = true
      this.ishowoTypeDisabled = false
    },

    closeEditDialog1(){
      this.isTooffset = false
    },

    closeEditDialog() {
      this.Titlecenter = ''
      this.inputValue1 = ''
      this.inputValue2 = 0
      this.inputValue3 = ''
      this.inputID = ''

      this.value1 = ''
      this.value2 = []
      this.value3 = []

      this.input11 = ''
      this.resumeNumber33 = ''
      this.input3333 = ''
      this.input333333 = ''
      this.input2222 =''


      this.addShow = false
    },

    

       // 合计行内容
    getSummaries({ columns, data }) {
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 8 || column.property === 'teacherId') {
            sums[index] = '汇总';
          } 
          else if (column.property && this.summaryData[column.property] !== undefined) {
            sums[index] = this.summaryData[column.property];
          } else if (data.length === 0 && index >= 3) {
            // 没有数据时也展示“总计：”
            sums[index] = '';
          } else {
            sums[index] = '';
          }
        });
        return sums;
    },
   
    tableSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 最后一行（合计行）合并前3列
      if (rowIndex === this.dataList.length && columnIndex === 0) {
        return [1, 10]; // 合并1行3列
      }
      if (rowIndex === this.dataList.length && (columnIndex === 1 ||  columnIndex === 2)) {
        return [0, 0]; // 被合并的单元格
      }
    },



    CourseCancellationhandleEmit(e) {
      this.CourseCancellationComponentsShow = e
    },

    searchBtns() {
      this.getApiList()
    },

    searchBtns1() {
      this.getApiList1()
    },

    clearBtns1() {
      this.value1 = ''
      this.value2 = []
      this.value3 = []
      this.getApiList1()
    },


    clearBtns() {
      this.input1 = ''
      this.input2 = []
      this.input3 = ''
      this.input4 = ''
      this.input33 = ''
      this.input333 = ''
      this.resumeNumber3 = ''

      this.pageNum = 1
      this.pageSize = 10

      this.getApiList()
    },

    exportBtns(){
      let data = {
        // pageNum: this.pageNum1,
        // pageSize: this.pageSize1,
        teacherId: this.input1,
        commitStartDate: this.input2 && this.input2.length > 0 ? this.input2[0]  : null,
        commitEndDate: this.input2 && this.input2.length > 0 ? this.input2[1]  : null,

        // auditStartDate: (this.value3 && this.value3.length > 0) ? this.value3[0] + ' 00:00:00' : null,
        // auditEndDate: (this.value3 && this.value3.length > 0) ? this.value3[1] + ' 00:00:00' : null,
        // integralId: this.value1,
      }
      axios.post(`${apiBaseUrl}/integralAudit/exportTeacherIntegral`, data, { responseType: "blob", headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
           if(response.status == 200){
               const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' })
               const downloadLink = document.createElement("a")
               downloadLink.href = URL.createObjectURL(blob)
               downloadLink.download = "收支管理.xlsx"
               downloadLink.click()
               this.$message({ message:'导出成功', type: "success" });
           } else{
              this.$message.error('导出失败')
           }
       }).catch((err) => {
          this.$message.error(err)
      })
    },


    getApiList1() {
      let data = {
        pageNum: this.pageNum1,
        pageSize: this.pageSize1,
        teacherId: this.teacherIditme.teacherId,
        commitStartDate: (this.value2 && this.value2.length > 0) ? this.value2[0] + ' 00:00:00' : null,
        commitEndDate: (this.value2 && this.value2.length > 0) ? this.value2[1] + ' 00:00:00' : null,
        auditStartDate: (this.value3 && this.value3.length > 0) ? this.value3[0] + ' 00:00:00' : null,
        auditEndDate: (this.value3 && this.value3.length > 0) ? this.value3[1] + ' 00:00:00' : null,
        integralId: this.value1,
      }
      axios.post(`${apiBaseUrl}/integralAudit/findTeacherIntegralPage`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
        if (res.data.code === 200) {
          let data = res.data.data
          this.dataList1 = data.records.records
          this.pageNum1= data.records.current ? data.records.current : 1
          this.pageSize1 = data.records.size ? data.records.size : 10
          this.total1 = data.records.total ? data.records.total : 0
          this.integralCount = data.integralCount

          if(data.records && data.records.records.length < 0){
            this.dataList1 = []
          }

          this.$message({ message:res.data.message, type: "success" });
        } else {

          this.$message.error(res.data.message)
        }
      }).catch((err) => {
        this.$message.error(err)
      })
    },

    getApiList() {
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        teacherId: this.input1,
        commitStartDate: this.input2 && this.input2.length > 0 ? this.input2[0]  : null,
        commitEndDate: this.input2 && this.input2.length > 0 ? this.input2[1]  : null,
      }
      axios.post(`${apiBaseUrl}/integralAudit/findTeacherIntegralSumPage`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
        if (res.data.code === 200) {
          let data = res.data.data

          let obj = { teacherId:"汇总：1999" }

          let arr = data.records
          arr.push(obj)
          this.dataList = arr

          this.pageNum = data.current ? data.current : 0
          this.pageSize = data.size ? data.size : 10
          this.total = data.total ? data.total : 0

          if(data.records && data.records.length < 0){
            this.dataList = []
          }

          this.$message({ message:res.data.message, type: "success" });
        } else {
          this.$message.error(res.data.message)
        }
      }).catch((err) => {
        this.$message.error(err)
      })
    },

    handleSizeChange(e) {
      this.pagepageSizeNum = e
      this.getApiList()
    },

    handleSizeChange1(e) {
      this.pageSize1 = e
      this.getApiList1()
    },


 


    handleCurrentChange(e) {
      this.pageNum = e
      this.getApiList()
    },


    handleCurrentChange1(e) {
      this.pageNum1= e
      this.getApiList1()
    },

    handleClickViewsTo(){
      this.isLayer = 3
    },


    handleClickViewTo(type, itme){
      this.$msgbox({
        title: '提示',
        message: `
          <p style="color: red; font-size: 15px;padding:10px 3px;">
            若您的发票已做用途确认，需要您在发起冲销后72小时内到税局系统进行审批确认后，才可完成本次冲销。
          </p>
          <div style="margin-top: 16px;padding: 10px 0px;">
            <span style="color: red;">*</span> 冲销原因：
            <select id="reason" style="margin-left: 8px; padding: 4px;width:70%;border: 1px solid #bdbaba;">
              <option id="showBg" value="">请选择冲销原因</option>
              <option id="showBg" value="1">盖章打印不清晰</option>
              <option id="showBg" value="2">更改发票类型</option>
              <option id="showBg" value="3">专票认证未通过</option>
              <option id="showBg" value="4">开票信息填写错误</option>
              <option id="showBg" value="5">金额错误</option>
              <option id="showBg" value="6">快递丢失</option>
              <option id="showBg" value="7">退款</option>
            </select>
          </div>
        `,
        showCancelButton: true,
        dangerouslyUseHTMLString: true,
        confirmButtonText: '提交冲销申请',
        cancelButtonText: '取消',
        confirmButtonClass:"sbut",
        cancelButtonClass:"Csbut",
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            const reason = document.getElementById('reason').value;
            if (!reason) {
              this.$message.warning('请选择冲销原因');
            } else {
              console.log('提交冲销申请:', reason);
              done();
            }
          } else {
            done();
          }
        }
      }).then(action => {
        if (action === 'confirm') {
          console.log('用户点击了提交冲销申请');
        }
      });
      

      this.$nextTick(() => {
        let sbut = document.getElementsByClassName("sbut")[0]
        sbut.style.backgroundColor = "#ff800e"
        sbut.style.color = "#fff"
        sbut.style.border = "1px solid #ff800e"

        let Csbut = document.getElementsByClassName("Csbut")[0]
        Csbut.style.backgroundColor = "#ffff"
        Csbut.style.color = "#000"
        Csbut.style.border = "1px solid #DCDFE6"
      })  

     

    },

    handleClickView(type, itme) {

      this.isLayer = 3
      
      let data = {
        deptId: "1817500568573329408",
        deptName: "测试部门",
        teacherId:3,
        gift: 3,
        points: 3,
        Time: "2023-10-01 00:00:00",
      }

      this.input11 = data.teacherId
      this.resumeNumber33Id = data.deptId
      this.resumeNumber33 = data.deptName
      this.input3333 = data.gift
      this.input333333 = data.points
      this.input2222 = data.Time


      if (type === '编辑') {
        console.log(itme)
        this.ishowoTypeDisabled = false
        this.Titlecenter = '编辑积分项目'

        this.inputValue1 = itme.inputValue1
        this.inputValue2 = itme.inputValue2
        this.inputValue3 = itme.inputValue3
        this.inputID = itme.id

        this.addShow = true

      }

      if (type === '详情') {
        console.log(itme)
        this.Titlecenter = '积分详情'
        this.ishowoTypeDisabled = true

        this.teacherIditme = itme

        this.addShow = true

        this.getApiList1()


      } 
      if (type === '删除') {
         console.log(itme)
        // 提示二次删除确认
        this.$confirm('确定删除该条信息吗?, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 发送删除请求
          axios.post(`${apiBaseUrl}/`, { id: itme.id }, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
            if (res.data.code === 200) {
              this.$message({ message: res.data.message, type: "success" });
              this.getApiList()
            } else {
              this.$message.error(res.data.message)
            }
          }).catch((err) => {
            this.$message.error(err)
          })
        })


      }


    },


  }

}
</script>


<style scoped lang="less">
.no-click {
  pointer-events: none;
}


</style>



// WEBPACK FOOTER //
// src/RevenueAndManagementAll/InvoiceManagement.vue